import React, { useState } from 'react';

const withQuery = (WrappedComponent) => (props) => {
  const { startedIndex = null } = props;
  const [tableIndex, setTableIndex] = useState(startedIndex);
  return <WrappedComponent {...props} tableIndex={tableIndex} setTableIndex={setTableIndex}/>;
};
export default withQuery;
